/* IZU Paros — collection page: live filter count, instant sort, Load more. The Filter / Sort sheets
   themselves are the shared component in izu-sheet.js. Vanilla JS, no dependencies. */
(() => {
  const root = document.querySelector("[data-coll]");
  if (!root) return;
  const sectionId = root.dataset.sectionId;

  // Section Rendering API: the same URL, returning only this section's HTML.
  const sectionUrl = href => { const u = new URL(href, location.origin); u.searchParams.set("section_id", sectionId); return u.toString(); };
  const fetchSection = href => fetch(sectionUrl(href), { credentials: "same-origin" }).then(r => { if (!r.ok) throw new Error(r.status); return r.text(); })
    .then(html => new DOMParser().parseFromString(html, "text/html"));


  // ---------- Sort: apply as soon as an option is chosen ----------
  root.querySelector("[data-coll-sort-form]")?.addEventListener("change", e => {
    if (e.target.name === "sort_by") e.currentTarget.requestSubmit ? e.currentTarget.requestSubmit() : e.currentTarget.submit();
  });

  // ---------- Filter: clean URLs + live "Show N pieces" ----------
  const filterForm = root.querySelector("[data-coll-filter-form]");
  const submitBtn = filterForm?.querySelector("[data-coll-submit]");
  const filterUrl = form => {
    const params = new URLSearchParams();
    for (const [k, v] of new FormData(form)) if (String(v).trim() !== "") params.append(k, v);
    const q = params.toString();
    return form.getAttribute("action") + (q ? "?" + q : "");
  };
  if (filterForm) {
    let timer = null, seq = 0;
    filterForm.addEventListener("submit", e => { e.preventDefault(); location.assign(filterUrl(filterForm)); });
    filterForm.addEventListener("input", () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const mine = ++seq;
        submitBtn.setAttribute("aria-busy", "true");
        fetchSection(filterUrl(filterForm)).then(doc => {
          if (mine !== seq) return;
          const n = Number(doc.querySelector("[data-coll-count]")?.dataset.collCount);
          if (!Number.isNaN(n)) submitBtn.textContent = n === 0 ? "No pieces match" : `Show ${n} ${n === 1 ? "piece" : "pieces"}`;
        }).catch(() => {}).finally(() => { if (mine === seq) submitBtn.removeAttribute("aria-busy"); });
      }, 250);
    });
  }

  // ---------- Load more: fetch the next page and append its cards ----------
  const grid = root.querySelector("[data-coll-grid]");
  const status = root.querySelector("[data-coll-status]");
  root.addEventListener("click", e => {
    const more = e.target.closest("[data-coll-more]");
    if (!more || !grid) return;
    e.preventDefault();
    if (more.getAttribute("aria-busy") === "true") return;
    more.setAttribute("aria-busy", "true");
    const label = more.textContent;
    more.textContent = "Loading…";
    fetchSection(more.href).then(doc => {
      const items = [...(doc.querySelector("[data-coll-grid]")?.children || [])];
      const firstNewCard = items.find(li => li.classList.contains("card"));
      items.forEach(li => grid.appendChild(li));
      const next = doc.querySelector("[data-coll-more]");
      if (next) { more.href = next.getAttribute("href"); more.textContent = label; more.removeAttribute("aria-busy"); }
      else more.closest(".coll__more")?.remove();
      const cards = items.filter(li => li.classList.contains("card")).length;
      if (status) status.textContent = `${cards} more ${cards === 1 ? "piece" : "pieces"} loaded.`;
      firstNewCard?.querySelector(".card__name")?.focus({ preventScroll: true });
    }).catch(() => { location.assign(more.href); });
  });
})();
